// CREATE REVIEW 
export const CREATE_REVIEW_REQUEST ='CREATE_REVIEW_REQUEST';
export const CREATE_REVIEW_SUCCESS ='CREATE_REVIEW_SUCCESS';
export const CREATE_REVIEW_FAIL ='CREATE_REVIEW_FAIL';
export const CREATE_REVIEW_RESET ='CREATE_REVIEW_RESET';




export const CLEAR_ERROR ='CLEAR_ERROR';